var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlastic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 262.059,
    height: 165,
    viewBox: "0 0 262.059 165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 262.059,
    height: 165,
    rx: 8.576,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID-2",
    "data-name": "SVGID",
    width: 262.059,
    height: 165,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_74",
    x: 21.5,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_75",
    x: 31.5,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_76",
    x: 41.5,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_77",
    x: 51.5,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_74-2",
    x: 75.501,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_75-2",
    x: 85.501,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_76-2",
    x: 95.501,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_77-2",
    x: 105.501,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_74-3",
    x: 134.499,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_75-3",
    x: 144.499,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_76-3",
    x: 154.499,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_77-3",
    x: 164.499,
    y: 91.5,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.278
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "_1234_5678_9",
    x: 23,
    y: 115.5,
    width: 52,
    height: 17,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.302
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(-57 -48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5886",
    "data-name": "Group 5886",
    transform: "translate(57 48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5885",
    "data-name": "Group 5885",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5884",
    "data-name": "Group 5884"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3092",
    "data-name": "Rectangle 3092",
    width: 262.059,
    height: 165,
    fill: "#004292"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5874",
    "data-name": "Group 5874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5873",
    "data-name": "Group 5873",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5872",
    "data-name": "Group 5872",
    transform: "translate(-7.465 -109.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18222",
    "data-name": "Path 18222",
    d: "M221.526,244.207,120.455,71.377l101.072-172.83L322.6,71.377Z",
    transform: "translate(5.913 104.453)",
    fill: "#0b1622"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1241",
    "data-name": "Ellipse 1241",
    cx: 106.353,
    cy: 106.353,
    r: 106.353,
    transform: "translate(-11 155.573)",
    fill: "#f9893c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18223",
    "data-name": "Path 18223",
    d: "M190.4,179.359A106.469,106.469,0,0,0,128.069,46.734l-7.614,13.02Z",
    transform: "translate(5.913 116.076)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5875",
    "data-name": "Group 5875",
    transform: "translate(73.688 58.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18224",
    "data-name": "Path 18224",
    d: "M80.624,62.438a16.371,16.371,0,0,0-1.583-4.979,4.287,4.287,0,0,0-.521-.854.908.908,0,0,0-1.021-.063,1.009,1.009,0,0,0-.417.708,5.864,5.864,0,0,0,.438.979,13.5,13.5,0,0,1,1.542,6.479,13.806,13.806,0,0,1-1.646,6.73c-.291.541-.333.688-.291.875a1,1,0,0,0,.6.708.954.954,0,0,0,.292.041.523.523,0,0,1,.188-.021c.25,0,.541-.4,1-1.375a16.674,16.674,0,0,0,1.5-5.084A21.289,21.289,0,0,0,80.624,62.438Z",
    transform: "translate(-67.632 -56.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18225",
    "data-name": "Path 18225",
    d: "M76.507,60.914a11.65,11.65,0,0,0-1.25-2.6.909.909,0,0,0-1.25.1c-.272.4-.25.542.208,1.5a9.824,9.824,0,0,1,1.125,3.959,10.367,10.367,0,0,1-1.062,5.584c-.208.416-.4.833-.438.937a.884.884,0,0,0,.583,1c.6.188,1.042-.272,1.646-1.709A12.381,12.381,0,0,0,76.507,60.914Z",
    transform: "translate(-67.557 -56.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18226",
    "data-name": "Path 18226",
    d: "M71.39,59.807a.662.662,0,0,0-.563.23c-.4.375-.4.562.084,1.52a6.974,6.974,0,0,1-.042,6.563c-.291.6-.354.792-.333.958a.868.868,0,0,0,.937.708c.4-.063.584-.271.98-1.062a7.941,7.941,0,0,0,.937-3.917,8.251,8.251,0,0,0-.9-3.917C72.1,60.037,71.848,59.807,71.39,59.807Z",
    transform: "translate(-67.481 -56.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18227",
    "data-name": "Path 18227",
    d: "M68.131,61.406a.863.863,0,0,0-.688,1.021,3.627,3.627,0,0,0,.292.583,3.672,3.672,0,0,1,0,3.626c-.313.5-.375.708-.292.958a1,1,0,0,0,.5.583c.438.187.854-.021,1.229-.6a5.145,5.145,0,0,0,0-5.5C68.8,61.51,68.527,61.343,68.131,61.406Z",
    transform: "translate(-67.41 -56.53)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3093",
    "data-name": "Rectangle 3093",
    width: 36.24,
    height: 28.086,
    rx: 5.745,
    transform: "translate(25.412 51.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "uuid-1d1a67cd-8df2-491b-b025-a1d6cc036557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-0eb24f92-9102-4a95-bfa8-e126fcecaa4f",
    transform: "translate(189.74 18.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-d6552bd9-223a-4431-83c1-f449e98ec254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-29823ee8-dd80-4682-b02f-cdc5554c9eec"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-542c1dda-625b-4300-b3bc-1e0c43be3294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-e5f811aa-d6c9-409a-9e8e-38f1fe0b5beb",
    d: "M21.719.329,14.231,18.194H9.346L5.659,3.936a1.959,1.959,0,0,0-1.1-1.569A19.258,19.258,0,0,0,0,.848L.109.327H7.975a2.153,2.153,0,0,1,2.132,1.82l1.951,10.34L16.865.327h4.854ZM40.862,12.361c.019-4.714-6.52-4.975-6.474-7.081.012-.641.624-1.322,1.96-1.5a8.765,8.765,0,0,1,4.559.8l.81-3.788A12.368,12.368,0,0,0,37.393,0c-4.566,0-7.782,2.429-7.809,5.906-.029,2.572,2.294,4,4.045,4.862,1.8.875,2.4,1.436,2.4,2.219-.014,1.2-1.438,1.728-2.765,1.748a9.652,9.652,0,0,1-4.748-1.127l-.837,3.916a14.02,14.02,0,0,0,5.14.948c4.854,0,8.029-2.4,8.045-6.112m12.063,5.833H57.2L53.472.324H49.524a2.106,2.106,0,0,0-1.966,1.312L40.625,18.189h4.85l.965-2.667h5.928l.556,2.667ZM47.77,11.862,50.2,5.152l1.4,6.709H47.772ZM28.321.329,24.5,18.194H19.877L23.7.329h4.622Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40075",
    "data-name": "Group 40075",
    transform: "translate(37.483 22.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36522",
    "data-name": "Path 36522",
    d: "M219.78,133.411a10.824,10.824,0,0,1,1.61-.121,3.363,3.363,0,0,1,2.377.732,2.7,2.7,0,0,1,.827,2.106,3.112,3.112,0,0,1-.844,2.28,3.614,3.614,0,0,1-2.594.844,12.067,12.067,0,0,1-1.376-.07Zm.757,5.188a4.853,4.853,0,0,0,.766.044,2.256,2.256,0,0,0,2.5-2.49,2.093,2.093,0,0,0-2.377-2.263,4.255,4.255,0,0,0-.889.078V138.6Z",
    transform: "translate(-219.78 -133.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36523",
    "data-name": "Path 36523",
    d: "M253.792,145.03a1.35,1.35,0,0,0,1.445,1.463,2.749,2.749,0,0,0,1.167-.218l.131.549a3.428,3.428,0,0,1-1.4.261,1.956,1.956,0,0,1-2.072-2.123,2.045,2.045,0,0,1,1.977-2.272,1.785,1.785,0,0,1,1.741,1.985,2.932,2.932,0,0,1-.026.356h-2.961Zm2.246-.549a1.091,1.091,0,0,0-1.063-1.245,1.271,1.271,0,0,0-1.175,1.245h2.238Z",
    transform: "translate(-247.384 -140.816)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36524",
    "data-name": "Path 36524",
    d: "M281.222,137.881c.017-.287.034-.715.034-1.088V131.7h.757v2.647h.017a1.567,1.567,0,0,1,1.436-.774,1.889,1.889,0,0,1,1.775,2.151,2,2,0,0,1-1.89,2.255,1.5,1.5,0,0,1-1.41-.793h-.026l-.034.7h-.662Zm.793-1.688a1.458,1.458,0,0,0,.034.278,1.183,1.183,0,0,0,1.149.9c.8,0,1.279-.653,1.279-1.619,0-.844-.435-1.567-1.254-1.567a1.221,1.221,0,0,0-1.167.94,1.523,1.523,0,0,0-.044.314v.757Z",
    transform: "translate(-270.742 -131.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36525",
    "data-name": "Path 36525",
    d: "M311.88,133.969a.475.475,0,0,1-.95,0,.471.471,0,0,1,.479-.479A.459.459,0,0,1,311.88,133.969Zm-.853,5.4v-4.214h.766v4.214Z",
    transform: "translate(-295.385 -133.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36526",
    "data-name": "Path 36526",
    d: "M323.054,136.14v1.211h1.1v.583h-1.1v2.272c0,.522.148.819.575.819a1.647,1.647,0,0,0,.443-.053l.034.575a1.87,1.87,0,0,1-.679.1,1.059,1.059,0,0,1-.827-.322,1.557,1.557,0,0,1-.3-1.1v-2.3h-.653v-.583h.653v-1.01l.749-.2Z",
    transform: "translate(-304.276 -135.383)",
    fill: "#fff"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999",
    transform: "translate(5111 816)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5054, -768)",
    filter: "url(#Ellipse_74)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74-4",
    "data-name": "Ellipse 74",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(26 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5054, -768)",
    filter: "url(#Ellipse_75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75-4",
    "data-name": "Ellipse 75",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(36 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5054, -768)",
    filter: "url(#Ellipse_76)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76-4",
    "data-name": "Ellipse 76",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(46 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5054, -768)",
    filter: "url(#Ellipse_77)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77-4",
    "data-name": "Ellipse 77",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(56 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5054, -768)",
    filter: "url(#Ellipse_74-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74-5",
    "data-name": "Ellipse 74",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(80 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5054, -768)",
    filter: "url(#Ellipse_75-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75-5",
    "data-name": "Ellipse 75",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(90 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5054, -768)",
    filter: "url(#Ellipse_76-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76-5",
    "data-name": "Ellipse 76",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(100 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5054, -768)",
    filter: "url(#Ellipse_77-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77-5",
    "data-name": "Ellipse 77",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(110 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5054, -768)",
    filter: "url(#Ellipse_74-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74-6",
    "data-name": "Ellipse 74",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(139 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5054, -768)",
    filter: "url(#Ellipse_75-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75-6",
    "data-name": "Ellipse 75",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(149 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5054, -768)",
    filter: "url(#Ellipse_76-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76-6",
    "data-name": "Ellipse 76",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(159 96)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5054, -768)",
    filter: "url(#Ellipse_77-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77-6",
    "data-name": "Ellipse 77",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(169 96)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 57, 48)",
    filter: "url(#_1234_5678_9)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1234_5678_9-2",
    "data-name": "1234   5678   9",
    transform: "translate(49 127.5)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans, Open Sans",
    opacity: 0.485
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.002,
    y: 0
  }, "Card holder"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlastic);
export default __webpack_public_path__ + "static/media/plastic.71655c4787c5d03bd58d984bac05e23b.svg";
export { ForwardRef as ReactComponent };